import ThingsManagerClass from "../../libs/base/ThingsManagerClass";
import CalenderModalClass from "../common/CalenderModalClass";
import Util from "../../libs/util/Util";
import LtikeCommon from "../common/LtikeCommon";
import dayjs from "dayjs";
import PlaneTicketItemDetails from "./PlaneTicketItemDetails";
import RippleManagerClass from "../common/RippleManagerClass";

export default class PlaneTicket extends ThingsManagerClass {
    constructor(_parent) {
        super();
        this.parent = _parent;

        this.CL_LOADING = "isLoading";

        this.key = LtikeCommon.PREFIX+"_plane_ticket";
    }

    onCreate() {
        this.target = $('[data-id="plane_ticket"]',this.parent);
        this.target.css({display:"block"});

        this.things = {};

        this.isSortType = "0";

        this.things.simpleCalenderModal = new CalenderModalClass("simple_calender_ticket",this.parent);

        this.things.simpleCalenderModal.on(this.things.simpleCalenderModal.EVENT_POSITIVE,(e,p)=>{
            let date = dayjs(this.things.simpleCalenderModal.getData().going);
            //console.log("simpleCalenderModal.EVENT_POSITIVE",date);
            this.changeCalender(date);
        });
        super.onCreate();

        this.filterArea = $("."+this.key+"__nav__filter",this.target);

        $('[name="upgrade"]',this.filterArea).on("change",this.onChange_upgrade.bind(this));
        $('[name="datechange"]',this.filterArea).on("change",this.onChange_datechange.bind(this));

        $(`.${this.key}__nav__sort li a`,this.target).on("click",this.onClick_sort.bind(this));

        this.embed = $("."+this.key+"__list",this.target);
        this.depTxt = $(`.${this.key}__nav__date .-date`,this.target);
        this.errorMsg = $(`.${this.key}__error_msg`,this.target);
    }

    onChangeBreakPoint(b) {
        super.onChangeBreakPoint(b);

        //console.log("onChangeBreakPoint0",this.things.calenderModal,this.things.calenderModal.things.calender,Util.MASTER_AIRPLANE_TICKET);
        if(!this.things.simpleCalenderModal || !this.things.simpleCalenderModal.things.calender || !Util.MASTER_AIRPLANE_TICKET) return;
        this.things.simpleCalenderModal.onClose(this.EVENT_NEGATIVE);
        this.things.simpleCalenderModal.things.calender.isSlide = (!Util.isBreakpoint);
        this.onSetData();

    }

    onSetDefaultData(_json){
        //console.log("onSetDefaultData",_json);

        this.airportData = Util.MASTER_AIRPORT_DATA;
        this.priceList = Util.MASTER_AIRPLANE_PRICE_LIST;

        this.things.simpleCalenderModal.onSetData(Util.MASTER_AIRPLANE_TICKET.calender_term);
        this.things.simpleCalenderModal.setOneWay(true);
        //this.things.simpleCalenderModal.onSetDate(LtikeCommon.AIRPLANE.DEFAULT_DATE.going);

        /*const ttl = $("."+LtikeCommon.PREFIX+"_plane_ticket__ttl");
        $('[name="plane_ticket_from"]',ttl).text(this.airportData[_json.from].disp_name);
        $('[name="plane_ticket_to"]',ttl).text(this.airportData[_json.to].disp_name);
        console.log(this.airportData[_json.from].disp_name,this.airportData[_json.to].disp_name)*/

        this.json = _json;
        this.departureCode = _json.from;
        this.arriveCode = _json.to;
        this.onSetCalenderPrice();

        let params = "";

        params += "adtnum="+_json.passengers.adult;
        params += "&chdnum="+_json.passengers.ageList.length;
        params += '&chdage='+_json.passengers.ageList.join(",");
        params += "&seg="+_json.from+"-"+_json.to+"-";

        //一週間後を設定
        const date = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(7,"d");
        params += date.format('YYYYMMDD');

        this.depTxt.text(date.format('YYYY年MM月DD日出発'));

        this.things.simpleCalenderModal.onSetDate({going:date,back:date});

        //console.log(params);
        this.params = params;
        Util.apiCall({
                url:LtikeCommon.API.AIRPLANE_TICKET+"?"+params
            },
            this.apiCallback.bind(this),
            this.apiCallBackError.bind(this)
        );

    }

    onSetData() {
        this.airportData = Util.MASTER_AIRPORT_DATA;
        this.priceList = Util.MASTER_AIRPLANE_PRICE_LIST;
        this.things.simpleCalenderModal.onSetData(Util.MASTER_AIRPLANE_TICKET.calender_term);
        this.things.simpleCalenderModal.setOneWay(true);
        this.onSetCalenderPrice();
    }

    onSetCalenderPrice(){
        const dCode = this.departureCode;
        const aCode = this.arriveCode;
        let price = Util.getPriceList(dCode,aCode);
        this.things.simpleCalenderModal.onSetPrice(price);
    }

    changeCalender(_date){
        //console.log("changeCalender",_date);

        this.target.addClass(this.CL_LOADING);
        this.embed.empty();
        this.itemsDetails.forEach(item=>item.onRemove());
        this.itemsDetails = [];
        delete this.itemsDetails;
        this.items = null;
        delete this.items;


        let params = "";

        params += "adtnum="+this.json.passengers.adult;
        params += "&chdnum="+this.json.passengers.ageList.length;
        params += '&chdage='+this.json.passengers.ageList.join(",");
        params += "&seg="+this.json.from+"-"+this.json.to+"-";

        params += _date.format('YYYYMMDD');

        this.depTxt.text(_date.format('YYYY年MM月DD日出発'));

        //console.log(params);
        this.params = params;
        Util.apiCall({
                url:LtikeCommon.API.AIRPLANE_TICKET+"?"+params
            },
            this.apiCallback.bind(this),
            this.apiCallBackError.bind(this)
        );
    }

    apiCallback(_data){
        //console.log("apiCallback",_data);
        this.errorMsg.hide();

        const AIRPORT_DATA = Util.MASTER_AIRPORT_DATA;

        const items = Util.checkItems(_data.catalog.response.catalogdata.airon.air.airavaillist.airavailitem.airitemlist.airitem);
        //console.log(items);

        const airline = {};
        _data.airline.item.forEach((a)=>{
            airline[a.code3] = a;
        });

        const airlineIds = [];
        const tickets = [];
        items.forEach((item)=>{
            const flight = item.flightschedule.flightseglist.flightsegitem;
            const data = {
                airline:{
                    logo:airline[flight.airlinecode].icon_url,
                    name:flight.airlinecode+""+flight.flightno,
                    code:flight.airlinecode,
                    disporder:item.flightschedule.disporder
                },
                dep:{
                    time:flight.deptime,
                    name:AIRPORT_DATA[flight.depairportcode].namej
                },
                arv:{
                    time:flight.arvtime,
                    name:AIRPORT_DATA[flight.arvairportcode].namej
                },
                item:[],
                price:0,
                id:item.airitemid
            };
            const fare = Util.checkItems(item.fare.farelist.fareitem);
            if(airlineIds.indexOf(flight.airlinecode) === -1) airlineIds.push(flight.airlinecode);

            function setData(f){
                const d = {
                    id:f.fareitemid,
                    kind: f.change == 0 ? 'static' : '',
                    category:f.farename,
                    category_type:f.farecategory,
                    price:f.unit.adult.base,
                    point:f.pontapoint,
                    bonus:parseInt(f.pontapointcourseadd) + parseInt(f.pontapointairlineadd),
                    seat:f.seatclassname,
                    seatcount:f.seatcount,
                    seatclass:f.seatclass,
                    change:f.change
                };
                data.item.push(d);
            }

            fare.forEach((f)=>{
                setData(f);
            });

            data.price = data.item[0].price;

            tickets.push(data);
        });
        //console.log(tickets);
        //console.log(airlineIds);

        if(this.filterCompanyRipple){
            this.filterCompanyRipple.onRemove();
            this.filterCompanyRipple = null;
        }

        let airlineListHtml = '';
        airlineIds.forEach((id)=>{
            airlineListHtml += `<label class="${this.key}__nav__filter__company__item js-ripple">
                                <input type="checkbox" name="airline" value="${id}" checked>
                                <span class="${this.key}__nav__filter__company__item__body">
                                <span class="${this.key}__nav__filter__company__item__img"><img loading="lazy" src="${LtikeCommon.IMAGE_URL}${airline[id].icon_url}" alt="${id}"></span>
                                <span class="${this.key}__nav__filter__company__item__icon" data-type="icon"></span>
                                </span>
                            </label>`;
        });
        const filterAirlineCompany = $("."+this.key+"__nav__filter__company",this.target);
        filterAirlineCompany.html(airlineListHtml);
        $('[name="airline"]',filterAirlineCompany).on("change",this.onChange_airline.bind(this));

        this.filterCompanyRipple = new RippleManagerClass(filterAirlineCompany);
        this.filterCompanyRipple.onCreate();

        const hrefBase = `https://tour.l-tike.com/flights/domestic/search_result?methoditinerary=1&${this.params}&id=`;

        let html = '';
        tickets.forEach((t)=>{
            const prefix = LtikeCommon.PREFIX+"_plane_ticket";
            html += `<details class="${this.key}__item" data-price="${t.price}" data-code="${t.airline.code}" data-time="${t.dep.time.split(":")}" data-disporder="${t.airline.disporder}">
                        <summary class="${this.key}__item__summary js-ripple">
                        <span class="${this.key}__item__summary__plane">
                            <img loading="lazy" src="${LtikeCommon.IMAGE_URL+t.airline.logo}" alt="">
                            <span>${t.airline.name}</span>
                        </span>
                            <span class="${this.key}__item__summary__departure">
                            <span>${t.dep.name}</span>
                            <span>${t.dep.time}</span>
                        </span>
                            <span class="${this.key}__item__summary__arrow">→</span>
                            <span class="${this.key}__item__summary__arrive">
                            <span>${t.arv.name}</span>
                            <span>${t.arv.time}</span>
                        </span>
                            <span class="${this.key}__item__summary__price">${Util.commaPunctuation(t.price)}</span>
                        </summary>
                        <div class="${this.key}__item__mask">
                            <div class="${this.key}__item__body">`;

            t.item.forEach((item)=>{
                //console.log(item);
                let vacantType = 3;
                let vacantTxt = "";
                switch (item.seatcount){
                    case '○':
                        vacantType = 1;
                        vacantTxt = "空席あり";
                        break;
                    case '△':
                        vacantType = 2;
                        vacantTxt = "残りわずか";
                        break;
                    default:
                        vacantTxt = "残り"+item.seatcount+"席";
                        break;
                }

                const href = hrefBase+t.id+"-"+item.id;
                html += `<a href="${href}" target="_blank" data-seetclass="${item.seatclass}" data-change="${item.change}" data-price="${item.price}" class="js-ripple">
                            <div class="${this.key}__item__vacant" data-type="${vacantType}"><span>${vacantTxt}</span></div>
                            <div class="${this.key}__item__category">${item.category}`;

                if(item.category_type === "SF"){
                    html += `<div class="${this.key}__item__category__sf">
                                <div class="-icon"></div>
                                <div class="-balloon">株主優待割引運賃の表示価格には、株主優待券仕入代金が含まれております。優待券は弊社で用意いたしますので、株主以外のお客様でもご利用可能です。</div>
                            </div>`;
                }

                html += `</div>`;
                html +=`<div class="${this.key}__item__seat_type">${item.seat}<span data-kind="${item.kind}"></span></div>
                            <div class="${this.key}__item__price">
                                <div class="${this.key}__item__price__n">${Util.commaPunctuation(item.price)}</div>
                            </div>
                            <div class="${this.key}__item__point">${Util.commaPunctuation(item.point)}ポイント${item.bonus > 0 ? `＋${Util.commaPunctuation(item.bonus)}ボーナスポイント` : ''}</div>
                        </a>`;
            });

            html += `</div></div></details>`;
        });
        this.embed.html(html);

        this.items = $(`.${this.key}__item`,this.target);

        this.itemsDetails = [];
        this.items.each((i,e)=>{
            this.itemsDetails.push(new PlaneTicketItemDetails(this.key,$(e)));
        });
        this.itemsDetails.forEach(item=>item.onCreate());

        this.target.removeClass(this.CL_LOADING);
    }

    apiCallBackError(_data){
        //console.log(_data);
        if(_data.errorcode){
            let msg = "";
            let code = "";
            if(_data.errorMessage){
                msg = _data.errorMessage;
                code = _data.errorcode;
            } else if(_data.catalog.response.error && _data.catalog.response.error.item && _data.catalog.response.error.item.errormessage){
                msg = _data.catalog.response.error.item.errormessage;
                code = _data.catalog.response.error.item.errorcode;
            }
            //console.error(code+":"+msg,_data);
            this.errorMsg.show();
            this.target.removeClass(this.CL_LOADING);
        }
    }

    onChange_airline(e){
        this.onFilter();
    }

    onChange_upgrade(e){
        this.onFilter();
    }

    onChange_datechange(e){
        this.onFilter();
    }

    onFilter(){
        const CL_NOT_SELECT = "isNotSelect";

        const isUpgrade = $('[name=upgrade]',this.target).prop("checked");
        const isDateChange = $('[name=datechange]',this.target).prop("checked");

        //console.log("onFilter",isUpgrade,isDateChange);
        //console.log(this.items);

        const aIds = [];
        $('[name=airline]',this.target).filter(":checked").each((i,e)=>{
            aIds.push($(e).val());
        });
        //console.log(aIds);

        this.items.each((i,e)=>{
            const _this = $(e);
            const item = $("a",_this);
            item.each((n,a)=>{
                let isShow = true;
                const _t = $(a);
                if(isUpgrade){
                    if(_t.attr("data-seetclass") === "Y"){
                        isShow = false;
                    }
                }

                if(isDateChange){
                    if(_t.attr("data-change") === "0"){
                        isShow = false;
                    }
                }

                if(isShow){
                    _t.removeClass(CL_NOT_SELECT);
                } else {
                    _t.addClass(CL_NOT_SELECT);
                }
            });

            let isShow = true;
            const code = _this.attr("data-code");
            if(aIds.indexOf(code) === -1) isShow = false;
            //console.log(item,item.filter(`:not(.${CL_NOT_SELECT})`).length);

            const child = item.filter(`:not(.${CL_NOT_SELECT})`);

            if(child.length <= 0){
                isShow = false;
            } else {
                const price = child.eq(0).attr("data-price");
                _this.attr({"data-price":price});
                $(`.${this.key}__item__summary__price`,_this).text(Util.commaPunctuation(price));
            }

            if(isShow){
                _this.removeClass(CL_NOT_SELECT);
            } else {
                _this.addClass(CL_NOT_SELECT);
            }

        });
    }

    onClick_sort(e){
        e.preventDefault();
        const _this = $(e.currentTarget);

        const sortType = _this.attr("data-n");
        if(sortType === this.isSortType) return;
        this.isSortType = sortType;

        const CL_ACTIVE = "isActive";

        const li = $("li",_this.closest('ul'));
        const index = li.index(_this.closest("li"));
        li.removeClass(CL_ACTIVE).eq(index).addClass(CL_ACTIVE);

        let sortFunc;
        let retPrice = 0;
        let retTime = 0;
        switch (sortType) {
            case "0":
                //価格が安い順
                sortFunc = (a, b) => {
                    retPrice = this.sortByPrice(a, b, true);
                    // 価格が同じなら、出発時間の早い順
                    if (0 === retPrice) {
                        retTime = this.sortByTime(a, b);
                        // 価格も出発時間も同じなら、航空会社表示優先順
                        if (0 === retTime) {
                            return this.sortByDisporder(a, b);
                        }
                        return retTime;
                    }
                    return retPrice;
                };
                break;
            case "1":
                sortFunc = (a, b) => {
                    retTime = this.sortByTime(a, b, false);
                    // 出発時間が同じなら、価格の安い順
                    if (0 === retTime) {
                        retPrice = this.sortByPrice(a, b);
                        // 価格も出発時間も同じなら、航空会社表示優先順
                        if (0 === retPrice) {
                            return this.sortByDisporder(a, b);
                        }
                        return retPrice;
                    }
                    return retTime;
                };
                break;
            case "2":
                sortFunc = (a, b) => {
                    retTime = this.sortByTime(a, b, true);
                    // 出発時間が同じなら、価格の安い順
                    if (0 === retTime) {
                        retPrice = this.sortByPrice(a, b);
                        // 価格も出発時間も同じなら、航空会社表示優先順
                        if (0 === retPrice) {
                            return this.sortByDisporder(a, b);
                        }
                        return retPrice;
                    }
                    return retTime;
                };
                break;
        }

        this.items.sort(sortFunc).each((i,e)=>{
            this.embed.append(this.items.eq(i));
        });
    }

    sortByPrice(a, b, asc) {
        const sort_key_price = 'data-price';
        const aVal = $(a).attr(sort_key_price) | 0;
        const bVal = $(b).attr(sort_key_price) | 0;
        if(asc){
            if (aVal > bVal) {
                $(b).after($(a));
                return 1;
            } else if (aVal < bVal) {
                $(b).before($(a));
                return -1;
            }
        } else {
            if (aVal > bVal) {
                $(b).after($(a));
                return -1;
            } else if (aVal < bVal) {
                $(b).before($(a));
                return 1;
            }
        }
        return 0;
    }

    sortByTime(a, b, desc) {
        const aTime = $(a).attr('data-time');
        const bTime = $(b).attr('data-time');
        if (desc) {
            if (aTime > bTime) {
                $(b).before($(a));
                return -1;
            } else if (aTime < bTime) {
                $(b).after($(a));
                return 1;
            }
        } else {
            if (aTime > bTime) {
                $(b).after($(a));
                return 1;
            } else if (aTime < bTime) {
                $(b).before($(a));
                return -1;
            }
        }
        return 0;
    }

    sortByDisporder(a, b) {
        const aDisporder = $(a).attr('data-disporder') | 0;
        const bDisporder = $(b).attr('data-disporder') | 0;
        if (aDisporder === 0) {
            $(b).after($(a));
            return 1;
        } else if (bDisporder === 0) {
            $(b).before($(a));
            return -1;
        } else if (aDisporder > bDisporder) {
            $(b).after($(a));
            return 1;
        } else if (aDisporder < bDisporder) {
            $(b).before($(a));
            return -1;
        }
        return 0;
    }
}